/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.string.link.js";
//
//
//
//
//
//
//
//
//
//
//
//
import PIC from '@/resources/images/noData.png';
export default {
  props: {
    show: Boolean,
    desc: String,
    src: {
      type: String,
      "default": PIC
    },
    width: String,
    pageType: String,
    routerName: String,
    link: String
  },
  data: function data() {
    return {};
  },
  computed: {
    emptyObj: function emptyObj() {
      var desc = this.desc,
          pageType = this.pageType;
      var data = {};
      data.src = this.src;

      if (!pageType) {
        data.desc = desc || '哦~什么都没有';
      } else {
        var emptyList = {
          'reg': {
            src: '',
            desc: ''
          },
          'bill': {
            src: '',
            desc: ''
          }
        };
        data = emptyList[pageType];
      }

      return data;
    },
    toEvent: function toEvent() {
      if (this.routerName) {
        this.$router.push({
          name: this.routerName
        });
      } else if (this.link) {
        window.location.href = this.link;
      }
    }
  }
};